import { render, staticRenderFns } from "./fdlerates.vue?vue&type=template&id=2f07cb63&scoped=true&"
import script from "./fdlerates.vue?vue&type=script&lang=js&"
export * from "./fdlerates.vue?vue&type=script&lang=js&"
import style0 from "./fdlerates.vue?vue&type=style&index=0&id=2f07cb63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f07cb63",
  null
  
)

export default component.exports